import {
  Box,
  Avatar,
  IconButton,
  Button,
  TextField,
  Popover,
  MenuItem,
  FormHelperText,
  CircularProgress,
} from "@mui/material";
import React, { useCallback, useState } from "react";
import styles from "./AgentsListing.module.css";
import ozonetel from "../../Assets/ozonetel.svg";
import help from "../../Assets/help.svg";
import CallbackUrlPopup from "../HelpPopup/CallbackUrlPopup";
import { FiEdit } from "react-icons/fi";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddIcon from "@mui/icons-material/Add";
import deleteImg from "../../Assets/deleteImg.svg";
import DeletePopup from "../DeletePopup/DeletePopup";
import UninstallOzontelPopup from "../DeletePopup/UninstallOzontelPopup";
import { useSelector } from "react-redux";
import { ValidateAgentId } from "../../../service/integrations.request";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import removeAgentIcon from "../../Assets/removeAgent.svg";
import Voxbay from "../../../../../../assets/images/Vox.png";

function AgentsListingComponent(props: any) {
  const {
    employees,
    appsList,
    instituteDetails,
    ozonetelEmployees,
    ozonetelConfigEmployees,
    DeactivateVoxbay,
    uninstallVoxbaySuccess,
    uninstallVoxbayLoading,
    AddVoxbayAgent,
    addVoxbayLoading,
    addVoxbaySuccess,
  } = props;
  const nonOzonetelEmployees = employees?.filter(
    (item: any) => item.ozonetelConfig?.agentId === ""
  );
  const ozonetelCallbackUrl = process.env.REACT_APP_VOXBAY_CALLBACK_URL || "";
  const ozonetelApp = appsList?.find((app: any) => app.appCode === "VOXBAY");
  const ozonetelAppApiKey = ozonetelApp?.appConfigData?.upin;
  const ozonetelAppUserName = ozonetelApp?.appConfigData?.uid;
  const [emptyAgentField, setEmptyAgentField] = React.useState<boolean>(false);
  const [invalidAgentsError, setInvalidAgentsError] =
    React.useState<boolean>(false);
  const [emptyExtensionAgentField, setEmptyExtensionAgentField] =
    React.useState<boolean>(false);
  const [invalidExtensionAgentsError, setInvalidExtensionAgentsError] =
    React.useState<boolean>(false);
  const [emptyDepartmentAgentField, setEmptyDepartmentAgentField] =
    React.useState<boolean>(false);
  const [invalidDepartmentAgentsError, setInvalidDepartmentAgentsError] =
    React.useState<boolean>(false);
  // const [emptyAgentField, setEmptyAgentField] = React.useState<boolean>(false);
  // const [invalidAgentsError, setInvalidAgentsError] =
  //   React.useState<boolean>(false);
  const [emptyCallerAgentField, setEmptyCallerAgentField] =
    React.useState<boolean>(false);
  const [invalidCallerAgentsError, setInvalidCallerAgentsError] =
    React.useState<boolean>(false);

  const [showCallbackUrlPopup, setShowCallbackUrlPopup] =
    useState<boolean>(false);
  const [editMode, setEditMode] = useState<boolean>(false);
  const [showDeletePopup, setShowDeletePopup] = useState<boolean>(false);
  const [showUninstallPopup, setShowUninstallPopup] = useState<boolean>(false);
  const [deleteSelectedAgent, setDeleteSelectedAgent] = useState<any>("");
  const [isCopied, setIsCopied] = useState<boolean>(false);
  const [tooltipTimeout, setTooltipTimeout] = useState<NodeJS.Timeout | null>(
    null
  );
  const handleUninstallPopupOpen = () => {
    setShowUninstallPopup(true);
  };

  const handleUninstallPopupClose = () => {
    setShowUninstallPopup(false);
  };
  const handleDeleteAgentPopupClose = () => {
    setShowDeletePopup(false);
    setDeleteSelectedAgent("");
  };

  const handleDeleteAgentPopupOpen = () => {
    setShowDeletePopup(false);
    setDeleteSelectedAgent("");
  };

  const handleDeleteClick = (agent: any) => {
    setDeleteSelectedAgent(agent);
    setShowDeletePopup(true);
  };

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCallbackUrlHelpClick = () => {
    setShowCallbackUrlPopup(true);
  };

  const toggleUninstallPopup = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleEditMode = () => {
    setEditMode(!editMode);
  };

  const handleCancelClick = () => {
    setEditMode(false);
  };

  const [agentsArray, setAgentsArray] = useState<any>([
    {
      userId: "",
      // agentId: "",
      // agentIdValid: false,
      // agentIdUnique: true,
      userName: "olivia779069",
      agentName: "olivia779069",
      extensionId: "",
      extensionIdValid: false,
      extensionIdUnique: true,
      departmentId: "",
      departmentIdValid: false,
      departmentIdUnique: true,
      callerId: "",
      callerIdValid: false,
      callerIdUnique: true,
    },
  ]);
  const [deletableAgentsArray, setDeletableAgentsArray] = useState<any>([]);

  const combinedArray = [...agentsArray, ...deletableAgentsArray];

  const handleDeleteNewlyAddedAgent = (indexToDelete: any) => {
    const updatedAgentsArray = agentsArray?.filter(
      (agent: any, index: number) => index !== indexToDelete
    );
    setAgentsArray(updatedAgentsArray);
  };

  const handleDeleteSubmit = async (event: any) => {
    event.preventDefault();

    try {
      const updatedAgentsArray = deletableAgentsArray?.map((item: any) => {
        if (item.userId === deleteSelectedAgent.userId) {
          return {
            userId: item.userId,
            extensionId: "",
            departmentId: "",
            callerId: "",
          };
        } else {
          return {
            userId: item.userId,
            agentExtensionNumber: item?.extensionId,
            departmentId: item?.departmentId,
            callerDIDNumber: item?.callerId,
          };
        }
      });

      AddVoxbayAgent(updatedAgentsArray);
    } catch (error) {}
  };

  const filteredExtensionAgents =
    agentsArray &&
    agentsArray?.filter(
      (item: any) =>
        item?.extensonId?.trim() !== "" && item?.extensionIdValid === true
    );
  const filteredExtensionInvalidAgents =
    agentsArray &&
    agentsArray?.filter(
      (item: any) =>
        // item?.extensionId?.trim() !== "" &&
        item?.extensionIdValid === false &&
        !/^[0-9]{3}$/.test(item?.extensionId)
    );

  const filteredDepartmentAgents =
    agentsArray &&
    agentsArray?.filter(
      (item: any) =>
        item?.departmentId?.trim() !== "" && item?.departmentIdValid === true
    );
  const filteredDepartmentInvalidAgents =
    agentsArray &&
    agentsArray?.filter(
      (item: any) =>
        // item?.departmentId?.trim() !== "" &&
        item?.departmentIdValid === false &&
        !/^[0-9][0-9]{0,2}$/.test(item?.departmentId)
    );

  const filteredCallerAgents =
    agentsArray &&
    agentsArray?.filter(
      (item: any) =>
        item?.callerId?.trim() !== "" && item?.callerIdValid === true
    );
  const filteredCallerInvalidAgents =
    agentsArray &&
    agentsArray?.filter(
      (item: any) =>
        // item?.callerId?.trim() !== "" &&
        item?.callerIdValid === false && !/^[0-9]{12}$/.test(item?.callerId)
    );

  const validateAgentsArray = (combinedArray: any[]) => {
    let hasError = false;

    for (const item of combinedArray) {
      if (!/^[0-9]{3}$/.test(item?.extensionId)) {
        setInvalidExtensionAgentsError(true);
        hasError = true;
      }

      if (!/^[0-9]{1,3}$/.test(item?.departmentId)) {
        setInvalidDepartmentAgentsError(true);
        hasError = true;
      }

      if (!/^[0-9]{12}$/.test(item?.callerId)) {
        setInvalidCallerAgentsError(true);
        hasError = true;
      }
    }

    return !hasError;
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    // const isValid = validateAgentsArray(combinedArray);
    // if (!isValid) return;

    if (filteredExtensionAgents?.length === 0) {
      setEmptyExtensionAgentField(true);
      return; // Stop the submission if there's no agentId
    }
    if (filteredDepartmentAgents?.length === 0) {
      setEmptyDepartmentAgentField(true);
      return; // Stop the submission if there's no agentId
    }
    if (filteredCallerAgents?.length === 0) {
      setEmptyCallerAgentField(true);
      return; // Stop the submission if there's no agentId
    }
    // if (filteredExtensionInvalidAgents?.length > 0) {
    //   setInvalidExtensionAgentsError(true);
    //   return;
    // }
    // if (filteredDepartmentInvalidAgents?.length > 0) {
    //   setInvalidDepartmentAgentsError(true);
    //   return;
    // }
    // if (filteredCallerInvalidAgents?.length > 0) {
    //   setInvalidCallerAgentsError(true);
    //   return;
    // }
    try {
      const updatedAgentsArray = combinedArray?.map((item: any) => ({
        userId: item.userId,
        agentExtensionNumber: item?.extensionId,
        departmentId: item?.departmentId,
        callerDIDNumber: item?.callerId,
      }));

      emptyExtensionAgentField === false &&
        emptyDepartmentAgentField === false &&
        emptyCallerAgentField === false &&
        AddVoxbayAgent(updatedAgentsArray);
    } catch (error) {}
  };

  React.useEffect(() => {
    if (filteredExtensionInvalidAgents?.length === 0) {
      setInvalidExtensionAgentsError(false);
    }
  }, [filteredExtensionInvalidAgents]);

  React.useEffect(() => {
    if (filteredDepartmentInvalidAgents?.length === 0) {
      setInvalidDepartmentAgentsError(false);
    }
  }, [filteredDepartmentInvalidAgents]);

  React.useEffect(() => {
    if (filteredCallerInvalidAgents?.length === 0) {
      setInvalidCallerAgentsError(false);
    }
  }, [filteredCallerInvalidAgents]);

  React.useEffect(() => {
    if (filteredExtensionAgents?.length > 0) {
      setEmptyExtensionAgentField(false);
    }
  }, [filteredExtensionAgents]);

  React.useEffect(() => {
    if (filteredCallerAgents?.length > 0) {
      setEmptyCallerAgentField(false);
    }
  }, [filteredCallerAgents]);

  React.useEffect(() => {
    if (filteredDepartmentAgents?.length > 0) {
      setEmptyDepartmentAgentField(false);
    }
  }, [filteredDepartmentAgents]);

  const handleDeactivateOzonetel = () => {
    DeactivateVoxbay(instituteDetails?.id);
  };

  const handleCopyClick = () => {
    navigator.clipboard.writeText(ozonetelCallbackUrl);
    setIsCopied(true);

    const timeout = setTimeout(() => {
      setIsCopied(false);
    }, 1000);

    // Save the timeout ID for cleanup
    setTooltipTimeout(timeout);
  };

  React.useEffect(() => {
    return () => {
      if (tooltipTimeout) {
        clearTimeout(tooltipTimeout);
      }
    };
  }, [tooltipTimeout]);

  React.useEffect(() => {
    if (uninstallVoxbaySuccess) {
      setShowUninstallPopup(false);
    }
  }, [uninstallVoxbaySuccess]);

  React.useEffect(() => {
    if (employees) {
      const defaultOzonetelEmployees = employees?.filter(
        (item: any) => !item.voxbayConfig
      );
      const defaultAgentsArray = defaultOzonetelEmployees?.map((item: any) => ({
        userId: item.id,
        userName: item.firstName + " " + item.lastName,
        extensionId: "",
        extensionIdValid: false,
        extensionIdUnique: true,
        departmentId: "",
        departmentIdValid: false,
        departmentIdUnique: true,
        callerId: "",
        callerIdValid: false,
        callerIdUnique: true,
      }));
      setAgentsArray(defaultAgentsArray);
    }
  }, [employees]);

  React.useEffect(() => {
    if (ozonetelEmployees) {
      const defaultAgentsArray = ozonetelConfigEmployees?.map((item: any) => ({
        userId: item.id,
        userName: item.firstName + " " + item.lastName,
        extensionId: item?.voxbayConfig?.agentExtensionNumber,
        extensionIdValid:
          item?.voxbayConfig?.agentExtensionNumber !== "" ? true : false,
        extensionIdUnique: true,
        departmentId: item?.voxbayConfig?.departmentId,
        departmentIdValid:
          item?.voxbayConfig?.departmentId !== "" ? true : false,
        departmentIdUnique: true,
        callerId: item?.voxbayConfig?.callerDIDNumber,
        callerIdValid:
          item?.voxbayConfig?.callerDIDNumber !== "" ? true : false,
        callerIdUnique: true,
      }));
      setDeletableAgentsArray(defaultAgentsArray);
    }
  }, [ozonetelEmployees]);

  React.useEffect(() => {
    if (addVoxbaySuccess === true) {
      setEditMode(false);
      setShowDeletePopup(false);
    }
  }, [addVoxbaySuccess]);

  const handleAgentIdChange = useCallback(
    (value: string, index: number, field: string) => {
      const updatedAgentsArray = [...agentsArray];

      // check duplicate for that specific field
      const isUnique = updatedAgentsArray.every(
        (agent: any, i: number) => i === index || agent[field] !== value
      );

      updatedAgentsArray[index] = {
        ...updatedAgentsArray[index],
        [field]: value, // <-- Update only this field
        [`${field}Unique`]: isUnique, // extensionIdUnique / departmentIdUnique / callerIdUnique
        [`${field}Valid`]: true, // reset validation for that field
      };

      setAgentsArray(updatedAgentsArray);
      if (field === "extensionId") setInvalidExtensionAgentsError(false);
      if (field === "departmentId") setInvalidDepartmentAgentsError(false);
      if (field === "callerId") setInvalidCallerAgentsError(false);
    },
    [agentsArray]
  );

  return (
    <>
      <Box
        style={{
          // width: "calc(100% - 456px)",
          paddingBottom: "100px",
        }}
      >
        <div
          style={{
            color: "#667085",
            fontSize: "16px",
            fontWeight: "500",
            marginBottom: "12px",
            textAlign: "left",
          }}
        >
          Voxbay Integration
        </div>
        <Box className={styles.AgentsListingWrapper}>
          <Box
            style={{
              display: "flex",
              borderBottom: "1px solid #E3E3E3",
              padding: "24px 24px 22px 24px",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>
                <img
                  src={Voxbay}
                  alt="ozonetel"
                  width={"30px"}
                  height={"30px"}
                />
              </div>
              <div className={styles.installedHead}>Voxbay Installed</div>
            </div>

            <IconButton
              aria-label="menu"
              id="long-button"
              onClick={toggleUninstallPopup}
            >
              <MoreVertIcon />
            </IconButton>

            <Popover
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              PaperProps={{
                style: {
                  boxShadow: "0px 4px 30px 0px rgba(0, 0, 0, 0.10)",
                  borderRadius: "4PX",
                  border: "1px solid #F2F2F2",
                },
              }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: 5,
                horizontal: 25,
              }}
            >
              <MenuItem
                sx={{
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "21px",
                  color: "#EC3939",
                  padding: "10px 18px",
                }}
                onClick={() => {
                  handleClose();
                  handleUninstallPopupOpen();
                }}
              >
                Uninstall
              </MenuItem>
            </Popover>
          </Box>

          <Box style={{ padding: "24px" }}>
            <div className={styles.ozonetelAccountDetailsWrap}>
              <div className={styles.ozonetelAccountDetailsItem}>
                <div
                  style={{ display: "flex", alignItems: "center" }}
                  className={styles.ozonetelDetailsItemHeading}
                >
                  Callback URL
                  <div onClick={handleCallbackUrlHelpClick}>
                    <img src={help} alt="help" style={{ cursor: "pointer" }} />
                  </div>
                </div>

                <div style={{ display: "flex", gap: "4px" }}>
                  <div className={styles.ozonetelDetailsItemContent}>
                    {ozonetelCallbackUrl}
                  </div>
                  <div
                    style={{ cursor: "pointer", position: "relative" }}
                    onClick={handleCopyClick}
                  >
                    <ContentCopyRoundedIcon
                      sx={{ color: "#667085" }}
                      fontSize="small"
                    />
                    {isCopied && (
                      <div
                        style={{
                          position: "absolute",
                          bottom: "18px",
                          left: "-58px",
                          background: "rgb(122 122 122 / 70%)",
                          color: "#fff",
                          padding: "6px 8px",
                          borderRadius: "3px",
                          fontSize: "11px",
                        }}
                      >
                        Copied
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className={styles.ozonetelAccountDetailsItem}>
                <div className={styles.ozonetelDetailsItemHeading}>UID</div>
                <div className={styles.ozonetelDetailsItemContent}>
                  {ozonetelAppUserName}
                </div>
              </div>
              <div className={styles.ozonetelAccountDetailsItem}>
                <div className={styles.ozonetelDetailsItemHeading}>UPIN</div>
                <div className={styles.ozonetelDetailsItemContent}>
                  {ozonetelAppApiKey}
                </div>
              </div>
            </div>

            <DeletePopup
              isOpen={showDeletePopup}
              onClose={handleDeleteAgentPopupClose}
              yesBtnClick={handleDeleteSubmit}
              agentAddedLoading={addVoxbayLoading}
            />
            <UninstallOzontelPopup
              isOpen={showUninstallPopup}
              onClose={handleUninstallPopupClose}
              yesBtnClick={handleDeactivateOzonetel}
              loader={uninstallVoxbayLoading}
              appName="Voxbay"
            />
            <CallbackUrlPopup
              isOpen={showCallbackUrlPopup}
              onClose={() => setShowCallbackUrlPopup(false)}
            />
          </Box>
        </Box>
        <div className={styles.agentListingBox}>
          <div className={styles.agentListingBoxHead}>
            <div className={styles.agent}>
              {editMode ? "Edit Agents" : "Agents"}
            </div>
            {!editMode && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  cursor: "pointer",
                  fontSize: "13px",
                  color: "#667085",
                }}
                onClick={handleEditMode}
              >
                <div style={{ marginTop: "2px" }}>Edit</div>
                <FiEdit size={12} color="#667085" />
              </div>
            )}
          </div>
          <div
            style={{
              padding: "16px 22px",
            }}
          >
            {!editMode &&
              ozonetelConfigEmployees?.map((agent: any, index: number) => (
                <div
                  key={index}
                  style={{
                    borderRadius: "6px",
                    border: "1px solid #F2F2F2",
                    background: "#FFF",
                    marginBottom: "16px",
                    padding: "12px 14px",
                  }}
                >
                  <div className={styles.addedAgentsListWrap}>
                    <div className={styles.agentCardDetailsWrap}>
                      <div className={styles.agentCardDetailsWrapLeft}>
                        <div className={styles.agentCardImg}>
                          <Avatar
                            alt="avatar"
                            sx={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "50%",
                              fontSize: "17px",
                              background: "#F5F5F7",
                              fontFamily: "Poppins",
                              fontWeight: "400",
                              border: "1px solid #EEEEF4",
                              color: "#667085",
                            }}
                            className={styles.agentAvatar}
                          >
                            <div>{agent?.firstName?.charAt(0)}</div>
                          </Avatar>
                        </div>
                        <div className={styles.agentName}>
                          {agent?.firstName + " " + agent?.lastName}
                        </div>
                      </div>

                      <div className={styles.userName}>
                        {`ExtensionID: ${agent?.voxbayConfig?.agentExtensionNumber}`}
                      </div>
                      <div className={styles.userName}>
                        {`Department ID: ${agent?.voxbayConfig?.departmentId}`}
                      </div>
                      <div className={styles.userName}>
                        {`Caller ID: ${agent?.voxbayConfig?.callerDIDNumber}`}
                      </div>
                    </div>
                  </div>
                </div>
              ))}

            {editMode && (
              <>
                {deletableAgentsArray?.map((agent: any, index: number) => (
                  <div
                    key={index}
                    style={{
                      borderRadius: "6px",
                      border: "1px solid #F2F2F2",
                      background: "#FFF",
                      marginTop: "16px",
                      padding: "12px 14px",
                    }}
                  >
                    <div className={styles.editAgentsFieldItemsWrap}>
                      <div className={styles.editAgentsFieldItemsWrapLeft}>
                        <div
                          className={styles.editAgentsFieldItemsWrapLeftItem}
                        >
                          <div className={styles.addAgentsFieldItemUserWrap}>
                            <div
                              className={
                                styles.addAgentsFieldItemUserWrapAvatar
                              }
                            >
                              {agent?.userName?.charAt(0)}
                            </div>
                            <div className={styles.addAgentsFieldItemUserName}>
                              {agent?.userName}
                            </div>
                          </div>
                        </div>
                        <div
                          className={styles.editAgentsFieldItemsWrapLeftItem}
                        >
                          <div
                            style={{
                              padding: "8px 18px",
                              height: "40px",
                              color: "#142C44",
                              fontSize: "14px",
                              minWidth: "366px",
                              maxWidth: "366px",
                              fontWeight: "500",
                              border: "1px solid #D4D4D8",
                              borderRadius: "6PX",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div>{agent?.extensionId}</div>
                            <button
                              className={styles.removeAgentBtn}
                              onClick={() => handleDeleteClick(agent)}
                            >
                              <img
                                src={removeAgentIcon}
                                alt="removeAgentIcon"
                              />
                            </button>
                          </div>
                          <div
                            style={{
                              padding: "8px 18px",
                              height: "40px",
                              color: "#142C44",
                              fontSize: "14px",
                              minWidth: "366px",
                              maxWidth: "366px",
                              fontWeight: "500",
                              border: "1px solid #D4D4D8",
                              borderRadius: "6PX",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              margin: "5px 0px",
                            }}
                          >
                            <div>{agent?.departmentId}</div>
                            <button
                              className={styles.removeAgentBtn}
                              onClick={() => handleDeleteClick(agent)}
                            >
                              <img
                                src={removeAgentIcon}
                                alt="removeAgentIcon"
                              />
                            </button>
                          </div>
                          <div
                            style={{
                              padding: "8px 18px",
                              height: "40px",
                              color: "#142C44",
                              fontSize: "14px",
                              minWidth: "366px",
                              maxWidth: "366px",
                              fontWeight: "500",
                              border: "1px solid #D4D4D8",
                              borderRadius: "6PX",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div>{agent?.callerId}</div>
                            <button
                              className={styles.removeAgentBtn}
                              onClick={() => handleDeleteClick(agent)}
                            >
                              <img
                                src={removeAgentIcon}
                                alt="removeAgentIcon"
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

                {agentsArray?.map((agent: any, index: number) => (
                  <div
                    key={index}
                    style={{
                      borderRadius: "6px",
                      border: "1px solid #F2F2F2",
                      background: "#FFF",
                      marginTop: "16px",
                      padding: "12px 14px",
                    }}
                  >
                    <div className={styles.editAgentsFieldItemsWrap}>
                      <div className={styles.editAgentsFieldItemsWrapLeft}>
                        <div
                          className={styles.editAgentsFieldItemsWrapLeftItem}
                        >
                          <div className={styles.addAgentsFieldItemUserWrap}>
                            <div
                              className={
                                styles.addAgentsFieldItemUserWrapAvatar
                              }
                            >
                              {agent?.userName?.charAt(0)}
                            </div>
                            <div className={styles.addAgentsFieldItemUserName}>
                              {agent?.userName}
                            </div>
                          </div>
                        </div>
                        <div
                          className={styles.editAgentsFieldItemsWrapLeftItem}
                        >
                          <div style={{ position: "relative" }}>
                            <TextField
                              fullWidth
                              inputProps={{
                                maxLength: 3, // <-- limit characters
                                inputMode: "numeric", // mobile numeric keyboard
                                pattern: "[0-9]*",
                                style: {
                                  padding: "9.5px 12px 9.5px 12px",
                                  color: "#142C44",
                                  fontSize: "14px",
                                  minWidth: "342px",
                                  fontWeight: "500",
                                },
                              }}
                              placeholder="Enter Extension ID"
                              value={agent?.extensionId}
                              onChange={(e) => {
                                const onlyNumbers = e.target.value.replace(
                                  /[^0-9]/g,
                                  ""
                                );
                                handleAgentIdChange(
                                  onlyNumbers,
                                  index,
                                  "extensionId"
                                );
                              }}
                            />
                            {!agent?.extensionIdValid &&
                              agent?.extensionId !== "" &&
                              agent?.extensionIdUnique && (
                                <FormHelperText error>
                                  Invalid extension id.
                                </FormHelperText>
                              )}
                            {agent?.extensionIdValid &&
                              agent?.extensionId !== "" &&
                              agent?.extensionIdUnique &&
                              /^[0-9]{3}$/.test(agent?.extensionId) && (
                                <FormHelperText sx={{ color: "#11c89b" }}>
                                  Valid extension id.
                                </FormHelperText>
                              )}
                            {!agent?.extensionIdUnique && (
                              <FormHelperText error>
                                Extension ID should be unique.
                              </FormHelperText>
                            )}
                          </div>
                          <div
                            style={{ position: "relative", margin: "5px 0px" }}
                          >
                            <TextField
                              fullWidth
                              inputProps={{
                                maxLength: 3, // <-- limit characters
                                inputMode: "numeric", // mobile numeric keyboard
                                pattern: "[0-9]*",
                                style: {
                                  padding: "9.5px 12px 9.5px 12px",
                                  color: "#142C44",
                                  fontSize: "14px",
                                  minWidth: "342px",
                                  fontWeight: "500",
                                },
                              }}
                              placeholder="Enter Department ID"
                              value={agent?.departmentId}
                              onChange={(e) => {
                                const onlyNumbers = e.target.value.replace(
                                  /[^0-9]/g,
                                  ""
                                );
                                handleAgentIdChange(
                                  onlyNumbers,
                                  index,
                                  "departmentId"
                                );
                              }}
                            />
                            {!agent?.departmentIdValid &&
                              agent?.departmentId !== "" &&
                              agent?.departmentIdUnique && (
                                <FormHelperText error>
                                  Invalid department id.
                                </FormHelperText>
                              )}
                            {agent?.departmentIdValid &&
                              agent?.departmentId !== "" &&
                              agent?.departmentIdUnique &&
                              /^[0-9][0-9]{0,2}$/.test(agent?.departmentId) && (
                                <FormHelperText sx={{ color: "#11c89b" }}>
                                  Valid department id.
                                </FormHelperText>
                              )}
                            {!agent?.departmentIdUnique && (
                              <FormHelperText error>
                                Department ID should be unique.
                              </FormHelperText>
                            )}
                          </div>
                          <div style={{ position: "relative" }}>
                            <TextField
                              fullWidth
                              inputProps={{
                                maxLength: 12, // <-- limit characters
                                inputMode: "numeric", // mobile numeric keyboard
                                pattern: "[0-9]*",
                                style: {
                                  padding: "9.5px 12px 9.5px 12px",
                                  color: "#142C44",
                                  fontSize: "14px",
                                  minWidth: "342px",
                                  fontWeight: "500",
                                },
                              }}
                              placeholder="Enter Caller ID"
                              value={agent?.callerId}
                              onChange={(e) => {
                                const onlyNumbers = e.target.value.replace(
                                  /[^0-9]/g,
                                  ""
                                );
                                handleAgentIdChange(
                                  onlyNumbers,
                                  index,
                                  "callerId"
                                );
                              }}
                            />
                            {!agent?.callerIdValid &&
                              agent?.callerId !== "" &&
                              agent?.callerId?.length < 12 &&
                              agent?.callerIdUnique && (
                                <FormHelperText error>
                                  Invalid caller id.
                                </FormHelperText>
                              )}
                            {agent?.callerIdValid &&
                              agent?.callerId !== "" &&
                              agent?.callerId?.length === 12 &&
                              agent?.callerIdUnique &&
                              /^[0-9]{12}$/.test(agent?.callerId) && (
                                <FormHelperText sx={{ color: "#11c89b" }}>
                                  Valid caller id.
                                </FormHelperText>
                              )}
                            {!agent?.callerIdUnique && (
                              <FormHelperText error>
                                Caller ID should be unique.
                              </FormHelperText>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}

            {editMode && (
              <>
                {(emptyExtensionAgentField ||
                  emptyDepartmentAgentField ||
                  emptyCallerAgentField) && (
                  <FormHelperText error>
                    Please fill atleast one valid agent id.
                  </FormHelperText>
                )}
                {(!emptyExtensionAgentField && invalidExtensionAgentsError) ||
                  (!emptyDepartmentAgentField &&
                    invalidDepartmentAgentsError) ||
                  (!emptyCallerAgentField && invalidCallerAgentsError && (
                    <FormHelperText error>
                      Please fill valid agent id or clear invalid agent ids.
                    </FormHelperText>
                  ))}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: "18px",
                    gap: "12px",
                  }}
                >
                  <Button
                    variant="outlined"
                    sx={{
                      color: "#344054",
                      textTransform: "capitalize",
                      fontWeight: "500",
                      display: "flex",
                      gap: "4px",
                      minWidth: "170px",
                      border: "1px solid #D0D5DD",
                      "&:hover": {
                        border: "1px solid #D0D5DD",
                        background: "#FFF",
                      },
                    }}
                    onClick={handleCancelClick}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    sx={{
                      textTransform: "capitalize",
                      fontWeight: "500",
                      display: "flex",
                      gap: "4px",
                      minWidth: "170px",
                    }}
                    onClick={handleSubmit}
                    disabled={!showDeletePopup && editMode && addVoxbayLoading}
                  >
                    {!showDeletePopup && editMode && addVoxbayLoading ? (
                      <CircularProgress size={20} color={"inherit"} />
                    ) : (
                      "Save Changes"
                    )}
                  </Button>
                </div>
              </>
            )}
          </div>
        </div>
      </Box>
    </>
  );
}

export default AgentsListingComponent;
